export default {"src":"/_next/static/media/pt.d6657783.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};